<ms-text-truncate [truncationSettings]="textTruncationConfig">
    @for (category of categories(); let i = $index; track i) {
        @if (!isEpcotEnabled && !isRewardDrawerEnabled && i > 0) {
            <span class="reward-token-card__separator"></span>
        }

        @if (isEpcotEnabled || isRewardDrawerEnabled) {
            @if (i > 0) {
                @if (optionCategoryIndex === i) {
                    <span class="reward-token-card__separator-colon">&#58;</span>
                } @else {
                    <span class="reward-token-card__separator reward-token-card_separator-new-reward-drawer"></span>
                }
            }
            <span
                [ngClass]="categories.length > 1 && i === 0 ? 'reward-token-card__category reward_live' : 'reward-token-card__category'"
                [innerHTML]="category | msTrust: 'html'">
            </span>
        }
        @if (!isEpcotEnabled && !isRewardDrawerEnabled) {
            <span class="reward-token-card__category" [innerHTML]="category | msTrust: 'html'"></span>
        }
    }

    @if (isRewardDrawerEnabled) {
        <span class="reward-token-card__separator reward-token-card_separator-new-reward-drawer"></span>
        <span class="reward-token-card__category">{{ betType }}</span>
    }
</ms-text-truncate>
